module.exports = __webpack_public_path__ + "img/WriteAI.be059b04.png";